export enum EnvironmentLevel {
  Local,
  Stage,
  Production,
  Development,
}
